/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper';
import * as Permission from "../util/Permission";

export const RELATION_TYPE_AUTO = "auto";
export const RELATION_TYPE_MANUAL = "manual";


export default declareEntity({
    entity: "relationDefs",
    graphQL: "RelationDef",
    dynamoPrefix: 'org',
    storageType: 'central',
    name: "Relation Definition",
    parentRelation: "relationDefs",
    defaultTitle: (data) => {
        return data['name'];
    },
    writePermission: [
        Permission.PERM_EDIT_CHANNEL,
    ],
    fields: (types) => { return {
        id: {
            name: "Relation Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (organisation) => {
                return organisation['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
        },
        externalId: {
            name: "External ID",
            type: "string",
            defaultValue: "",
            filterable: true,
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: "",
            required: true,
        },
        description: {
            name: "Description",
            type: "text",
            defaultValue: "",
        },
        type: {
            name: "Type",
            type: "enum",
            defaultValue: RELATION_TYPE_AUTO,
            values: {
                [RELATION_TYPE_AUTO]: {
                    name: "Automatic"
                },
                [RELATION_TYPE_MANUAL]: {
                    name: "Manual"
                }
            },
        },
        fromChannel: {
            name: "Source Channel",
            to: () => types['channels'],
            type: "relation",
        },
        toChannel: {
            name: "Target Channel",
            to: () => types['channels'],
            type: "relation",
        },
        fromEntity: {
            name: "Source Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
        },
        toEntity: {
            name: "Target Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
        },
        fromFieldEntity: {
            name: "Source Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
            visibility: (data) => { return data['type'] === RELATION_TYPE_AUTO; }
        },
        toFieldEntity: {
            name: "Target Entity Definition",
            to: () => types['entityDefs'],
            type: "relation",
            visibility: (data) => { return data['type'] === RELATION_TYPE_AUTO; }
        },
        fromField: {
            name: "Source Field Definition",
            to: () => types['fieldDefs'],
            type: "relation",
            relativeTo: ['fromFieldEntity'],
            visibility: (data) => { return data['type'] === RELATION_TYPE_AUTO; }
        },
        toField: {
            name: "Target Field Definition",
            to: () => types['fieldDefs'],
            type: "relation",
            relativeTo: ['toFieldEntity'],
            visibility: (data) => { return data['type'] === RELATION_TYPE_AUTO; }
        },
        fromFieldNameOrig: {
            name: "Original Source Field Name",
            description: "To help resolve issues when source field is removed",
            type: "string",
            defaultValue: "",
        },
        toFieldNameOrig: {
            name: "Original Target Field Name",
            description: "To help resolve issues when target field is removed",
            type: "string",
            defaultValue: "",
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
